import { fetchUtils } from 'react-admin';
import { getValidToken } from './session';

export const httpClient = async (url: string, options: any = {}) => {
  const opts = { ...options };

  if (!opts.headers) {
    opts.headers = new Headers({ Accept: 'application/json' });
  }

  // Attach a guaranteed-fresh ID token (refreshing transparently if the current
  // one has expired) so requests don't 401 after ~1h.
  const token = await getValidToken();
  if (token) {
    opts.headers.set('Authorization', `Bearer ${token}`);
  }

  return fetchUtils.fetchJson(url, opts);
};
